import { baseUrl } from '@/api/types';

export function waybillIndexUrl() {
  return `${baseUrl}/waybills`;
}

export function waybillCreateUrl() {
  return `${waybillIndexUrl()}/create`;
}

export function waybillDetailsUrl(waybillId) {
  return `${waybillIndexUrl()}/${waybillId}/details`;
}

export function waybillFileFormUrl() {
  return `${waybillIndexUrl()}/files`;
}

export function waybillStoreUrl() {
  return waybillIndexUrl();
}

export function waybillEditUrl(waybillId) {
  return `${waybillIndexUrl()}/${waybillId}/edit`;
}

export function waybillUpdateUrl(waybillId) {
  return `${waybillIndexUrl()}/${waybillId}`;
}

export function waybillDeleteUrl(waybillId) {
  return `${waybillIndexUrl()}/${waybillId}`;
}

export function waybillPdfPrintUrl(waybillId, language) {
  return `${baseUrl}/waybills/${waybillId}/pdf/print/${language}`;
}

export function waybillDownloadUrl(waybillId, language, format = 'pdf') {
  return `${baseUrl}/waybills/${waybillId}/${format}/download/${language}`;
}

export function waybillRestoreUrl(waybillId) {
  return `${baseUrl}/waybill-restore/${waybillId}`;
}
